module.exports = __webpack_public_path__ + "static/media/arrow.933264ce.svg";